export default __webpack_public_path__ + "static/media/firefox.9ca349af.svg";